// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2QFhr","selects":"Documents_selects__3Gyc6"};